import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { theme } from "../../../utils";

const steps = ["Organization Details", "Wash Types", "Review & Create"];

type OrganizationWizardStepperProps = {
  activeStep: number;
};

export const OrganizationWizardStepper = ({
  activeStep,
}: OrganizationWizardStepperProps) => {
  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        pt: { xs: 2, sm: 3 },
        pb: { xs: 2, sm: 3 },
      }}
    >
      <Typography sx={{ fontWeight: 600, fontSize: "20px" }}>
        Create Organization
      </Typography>
      <Typography sx={{ color: "#a6a6a6", fontSize: "14px", mb: 3 }}>
        Complete all steps to create your organization
      </Typography>
      <Stepper
        activeStep={activeStep}
        orientation="horizontal"
        sx={{
          display: { xs: "none", sm: "flex" },
          "& .MuiStep-root": {
            minWidth: 0,
          },
          "& .MuiStepIcon-root.Mui-active": {
            color: theme.palette.primary.main,
          },
          "& .MuiStepIcon-root.Mui-completed": {
            color: "#2e7d32",
          },
          "& .MuiStepLabel-label.Mui-active": {
            fontWeight: 600,
          },
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
